// ตารางความกว้างคอลัมน์ auto (เหมือน /finance/expenses) ไม่มีความกว้างตายตัวให้ตัด ellipsis แล้ว —
// ข้อความยาวขึ้นบรรทัดใหม่แทน (ชื่อ export คงไว้ให้ ExpenseRow ไม่ต้องแก้)
export const ellipsisSx = {
  wordBreak: 'break-word',
};

// สีพื้นหลังแถวหัวคอลัมน์ (ลำดับ/Expense Id/งาน-รหัสงบ/ยอดเบิก/รายละเอียด/อนุมัติ) ให้ตัดกับแถวข้อมูล
// ชัดเจน — ใส่ตรงที่ TableCell แต่ละอันเอง (ไม่ใช่ที่ TableRow) เพราะตารางเปิด stickyHeader ไว้ MUI
// sticky แต่ละ cell แยกกัน ถ้าใส่สีที่ TableRow เฉยๆ พอ scroll ผ่านพื้นหลังจะโปร่งใสมองทะลุเห็นแถวข้อมูลได้
// สไตล์เดียวกับหัวตารางของ /finance/expenses (ExpensesTableApplove.js: class bg-theme-600 + ตัวหนังสือขาว,
// sticky header ใช้สี rgb(var(--color-primary-600)) เหมือนกัน)
export const HEADER_BG = 'rgb(var(--color-primary-600))';
export const HEADER_CELL_SX = {
  bgcolor: HEADER_BG,
  color: '#fff',
};
